import './FailedChecks.less';
import React from 'react';
import moment from 'moment';
import { Card, Icon, Button, Empty } from 'antd';
import ImpactIndicator from '../shared/ImpactIndicator';
import { FailedCheck } from './types';

type Props = {
    failedChecks: FailedCheck[];
    title: string;
    type: 'url' | 'website';
    lastFoundDate?: string | null;
    isLoading?: boolean;
    isRunningBatchAnalysis?: boolean;
    onFailedCheckButtonClicked: (testKey: string) => void;
};

export default function FailedChecksSummaryList({
    failedChecks,
    title,
    type,
    isLoading,
    lastFoundDate,
    isRunningBatchAnalysis,
    onFailedCheckButtonClicked,
}: Props) {
    return (
        <Card
            className="deep-analysis-failed-checks"
            loading={isLoading}
            title={
                <div className="ant-card-meta-detail">
                    <div className="ant-card-meta-title">{title}</div>
                    {lastFoundDate && <div className="ant-card-meta-description">Found on {moment(lastFoundDate).format('MMM DD, YYYY')}</div>}
                </div>
            }
        >
            <div className="failed-checks-list">
                {failedChecks && failedChecks.length === 0 && <Empty description={isRunningBatchAnalysis ? 'No failed checks yet' : 'No failed checks'} />}
                {failedChecks &&
                    failedChecks.map((failedCheck) => (
                        <div
                            className="failed-check-item"
                            key={failedCheck.test_key}
                        >
                            <ImpactIndicator severity={failedCheck.relevance} />
                            <div className="item-description">
                                <span>{failedCheck.title}</span>
                                <span
                                    className="item-description-recommendation"
                                    dangerouslySetInnerHTML={{ __html: failedCheck.recommendation }}
                                />
                            </div>
                            <div>
                                <Button
                                    className="details-button"
                                    size="small"
                                    onClick={() => onFailedCheckButtonClicked(failedCheck.test_key)}
                                >
                                    {type === 'url' && (
                                        <>
                                            <Icon type="link" />
                                            {failedCheck.affected_urls ? ` ${failedCheck.affected_urls} URL${failedCheck.affected_urls > 1 ? 's' : ''}` : ''}
                                        </>
                                    )}
                                    {type === 'website' && (
                                        <>
                                            <Icon type="eye" /> View Details
                                        </>
                                    )}
                                </Button>
                            </div>
                        </div>
                    ))}
            </div>
        </Card>
    );
}
